import { AsyncScheduler } from './AsyncScheduler';
export var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler));
//# sourceMappingURL=QueueScheduler.js.map